import { i18n } from "./_translations";

import { ModuleModel } from "../Everou/_models";
import { Icons } from "../Common/_assets/icons/Icons";
import { ClientsModule } from "./ModuleClients/ClientsModule";
import { DistributorModule } from "./ModuleDistributor/DistributorModule";
import { ProductsModule } from "./ModuleProducts/ProductsModule";
import { BudgetsModule } from "./ModuleBudgets/BudgetsModule";
import { DocumentationModule } from "./ModuleDocumentation/DocumentationModule";
import { LicensesModule } from "./ModuleLicenses/LicensesModule";
import { DeviceSearchModule } from "./ModuleDeviceSearch/DeviceSearchModule";
import { LocationSearchModule } from "./ModuleLocationSearch/LocationSearchModule";
import { AppModulesFactory } from "../Common/AppModulesFactory";

const URLS = {
    DISTRIBUTOR:    "/distributor",
    BUDGETS:        "/budgets",
    CLIENTS:        "/clients",
    PRODUCTS:       "/products",
    DOCUMENTATION:  "/documentation",
    LICENSES:  "/licenses",
    DEVICE_SEARCH:  "/device-search",
    LOCATION_SEARCH: "/location-search",
};

const IDS = {
    DISTRIBUTOR: "DISTRIBUTOR",
    CLIENTS: "CLIENTS",
    PRODUCTS: "PRODUCTS",
    BUDGETS: "BUDGETS",
    DOCUMENTATION: "DOCUMENTATION",
    LICENSES: "LICENSES",
    DEVICE_SEARCH: "DEVICE_SEARCH",
    LOCATION_SEARCH: "LOCATION_SEARCH",
};

const componentForModuleDictionary = {
    [IDS.DISTRIBUTOR]:   DistributorModule,
    [IDS.CLIENTS]:       ClientsModule,
    [IDS.PRODUCTS]:      ProductsModule,
    [IDS.BUDGETS]:       BudgetsModule,
    [IDS.DOCUMENTATION]: DocumentationModule,
    [IDS.LICENSES]:      LicensesModule,
    [IDS.DEVICE_SEARCH]: DeviceSearchModule,
    [IDS.LOCATION_SEARCH]: LocationSearchModule,
};

function getEnabledModuleIds(hasDistributor, isReadOnly = false) {
    if (!hasDistributor)
        return [BudgetsModules.IDS.DISTRIBUTOR];

    const moduleIds = Object.values(BudgetsModules.IDS);
    return isReadOnly
        ? moduleIds.filter(id => id !== BudgetsModules.IDS.LICENSES)
        : moduleIds
    ;
}

const BUDGETS_MODULES = [
    /*ModuleModel({
        isEnabled: true,

        icon: Icons.files,
        moduleId: IDS.BUDGETS,
        uiName: i18n.t("mod_budgets_title"),
        url: URLS.BUDGETS,
    }),
    ModuleModel({
        isEnabled: true,

        icon: Icons.people,
        moduleId: IDS.CLIENTS,
        uiName: i18n.t("mod_clients_title"),
        url: URLS.CLIENTS,
    }),
    ModuleModel({
        isEnabled: true,

        icon: Icons.devices,
        moduleId: IDS.PRODUCTS,
        uiName: i18n.t("mod_products_title"),
        url: URLS.PRODUCTS,
    }),
    ModuleModel({
        isEnabled: true,

        icon: Icons.pdf,
        moduleId: IDS.DOCUMENTATION,
        uiName: i18n.t("mod_budgets_docs_title"),
        url: URLS.DOCUMENTATION,
    }),

    ModuleModel({
        isEnabled: true,

        icon: Icons.gear,
        moduleId: IDS.DISTRIBUTOR,
        uiName: i18n.t("mod_agent_title"),
        url: URLS.DISTRIBUTOR,
    }),*/

    ModuleModel({
        isEnabled: true,

        icon: Icons.receipt,
        moduleId: IDS.LICENSES,
        uiName: i18n.t("mod_licenses_title"),
        url: URLS.LICENSES,
    }),

    ModuleModel({
        isEnabled: true,

        icon: Icons.search,
        moduleId: IDS.DEVICE_SEARCH,
        uiName: i18n.t("mod_device_search_title"),
        url: URLS.DEVICE_SEARCH,
    }),

    ModuleModel({
        isEnabled: true,

        icon: Icons.home,
        moduleId: IDS.LOCATION_SEARCH,
        uiName: i18n.t("mod_location_search_title"),
        url: URLS.LOCATION_SEARCH,
    }),
];

export const BudgetsModules = {
    ...AppModulesFactory.makeModules({
        ALL_MODULES: BUDGETS_MODULES,
        componentForModuleDictionary,
        DEFAULT_MODULE: IDS.LICENSES,
    }),
    getEnabledModuleIds,
    URLS,
    IDS,
};
